import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

interface DatePickerInputProps {
    label?: string;
    selectedDate: Date | null;
    onDateChange: (date: Date | null) => void;
    required?: boolean;
}

const DatePickerInput: React.FC<DatePickerInputProps> = ({ label, selectedDate, onDateChange,required  }) => {
    return (
        <div className="mb-4">
            {label} {required && <span className="text-red-500">*</span>}
            <DatePicker
                selected={selectedDate}
                onChange={onDateChange}
                dateFormat="MM/dd/yyyy"
                placeholderText="Select date"
                className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary"
                maxDate={new Date()}
                showYearDropdown
                scrollableYearDropdown
                yearDropdownItemNumber={150} // Adjust this number to show more years
               
            />
        </div>
    );
};

export default DatePickerInput;
